/* eslint-disable eqeqeq */
import { Container, SvgIcon, Typography } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import {
  FiCheckCircle,
  FiChevronDown,
  FiClock,
  FiDownload,
  FiEye,
  FiFileText,
  FiUpload,
} from "react-icons/fi";
import { connect } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as approvedIcon } from "../../../../assets/custom-icons/check-circle.svg";
import documentImage from "../../../../assets/custom-icons/document-search.svg";
import { ReactComponent as informationIcon } from "../../../../assets/custom-icons/information-circle.svg";
import { ReactComponent as deniedIcon } from "../../../../assets/custom-icons/x-circle.svg";
import DocumentStatusEnum from "../../../../enums/DocumentStatusEnum";
import CrudActions from "../../../../partials/datatable/CrudActions";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../services/AppAPIService";
import Loading from "../../../home/components/Loading";
import { getLabelAndColorFromStatusHelper } from "../../pages/Lawsuit/helpers/getLabelAndColorFromStatusHelper";
import RejectingDocumentModal from "../Lawsuit/components/UserDocumentsDataTable/components/CreateModal/RejectingDocumentModal";
import RejectingDocumentModalInfo from "../Lawsuit/components/UserDocumentsDataTable/components/CreateModal/RejectingDocumentModalInfo";
import {
  getDisplayFromStatusHelper,
  getDisplayFromStatusHelperToAproveRejectDocuments,
} from "../Lawsuit/helpers/getDisplayFromStatusHelper";
import DatatableDocuments from "./components/datatableDocuments/DatatableDocuments";
import { isXavierThemeV2Enabled } from "../../../../utils/FeatureFlags";
import JSZip from "jszip";
import { USER_ROLES } from "../../../../enum/UserRoles";
import UploadModal from "../Lawsuit/components/Document/components/UploadModal/UploadModal";
import { ReactComponent as paperClipIcon } from "../../../../assets/custom-icons/paper-clip.svg";
import styles from "./styles.module.scss";

const DocumentValidation = (props) => {
  let api = AppAPIService.getInstance();
  const auth = { user: props.user };
  const userRole = props.user?.role;

  let crudActions =
    userRole !== USER_ROLES.ADMIN ? [] : ["toggle", "delete"];
  let crudOtherActions = ["download"];

  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [observationReject, setObservationReject] = useState("");
  const [rejectingDocumentId, setRejectingDocumentId] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showRejectModalInfo, setShowRejectModalInfo] = useState(false);

  const [showUpload, setShowUpload] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [documentList, setDocumentList] = useState([]);
  const [selectedUploadId, setSelectedUploadId] = useState("");
  const [requestSearch, setRequestSearch] = useState("");
  const [requestMenuOpen, setRequestMenuOpen] = useState(false);

  const uploadRequestOptions = documentList
    .filter(
      (document) =>
        document.status === DocumentStatusEnum.PENDING ||
        document.status === DocumentStatusEnum.REJECTED
    )
    .map((document) => ({
      value: document.id,
      label: document?.documentCategory?.name || "Documento solicitado",
    }));
  const selectedUploadRequest = uploadRequestOptions.find(
    (option) => String(option.value) === String(selectedUploadId)
  );
  const normalizedRequestSearch = requestSearch
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const filteredUploadRequestOptions = uploadRequestOptions.filter((option) =>
    option.label
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .includes(normalizedRequestSearch)
  );

  window.setPageTitle("Listagem de Documentos - Admin");

  const headRows = [
    { column: "", label: "Ações", sortable: false },
    { column: "userId", label: "Usuário", sortField: "username" },
    { column: "action", label: "Natureza da Ação", sortField: "action" },
    { column: "document", label: "Documento", sortField: "documentCategory" },
    { column: "adverseParty", label: "Parte Adversa", sortField: "adverseParty" },
    { column: "courtCaseNumber", label: "Nº Autos", sortField: "courtCaseNumber" },
    { column: "tipo", label: "Tipo do documento", sortField: "documentType" },
    { column: "status", label: "Status" },
    { column: "LimitDate", label: "Data de Limite", sortField: "limitDate" },
    { column: "updatedAt", label: "Ultima Atualização" },
  ];

  if (auth.user.role !== USER_ROLES.ADMIN) {
    headRows.splice(6, 1);
  }

  const handleConfirmChangeStatus = async ({ id, active }) => {
    try {
      await api.makeHttpRequest({
        method: "PATCH",
        url: `/document/toggle/${id}`,
      });

      const documentStatus = active ? "desativado" : "ativado";
      Swal.fire({
        title: "Sucesso!",
        text: `Documento ${documentStatus} com sucesso!`,
        icon: "success",
        cancelButtonText: "Sair",
      });
    } catch (error) {
      Swal.fire("Erro!", "Erro ao alterar status do documento.", "error");
    } finally {
      setLoading(false);
      setReload((prevReload) => !prevReload);
    }
  };

  const handleConfirmDelete = useCallback(
    async (id) => {
      setLoading(true);

      try {
        const result = await api.makeHttpRequest({
          method: "DELETE",
          url: `/document/${id}`,
        });

        if (result?.HttpStatus === 404) {
          Swal.fire(
            "Erro!",
            "Erro ao deletar documento, não encontrado.",
            "error"
          );
        } else if (result?.HttpStatus !== 200) {
          Swal.fire("Erro!", "Erro ao deletar documento.", "error");
        } else {
          Swal.fire("Sucesso!", "Documento deletado com sucesso.", "success");
          setReload((prevReload) => !prevReload);
        }
      } catch (error) {
        Swal.fire("Erro!", "Erro ao deletar documento.", "error");
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const handleDownloadAll = useCallback(
    async (files, documentId) => {
      if (!files || files.length === 0) {
        Swal.fire("Desculpe!", "Não contém arquivo!", "error");
        return;
      }

      Swal.fire({
        title: "Carregando...",
        html: "Aguarde um momento",
        showConfirmButton: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      const zip = new JSZip();
      const linkFiles = [];

      try {
        for await (const file of files) {
          if (file.fileKey) {
            const link = await api.makeHttpRequest({
              method: "GET",
              url: "/document/download",
              params: {
                fileKey: file.fileKey,
                documentId: documentId,
              },
            });
            linkFiles.push({ link, fileName: file.name });
          }
        }

        const errorMessages = [];

        if (linkFiles.length === 1) {
          const response = await fetch(linkFiles[0].link);

          if (!response.ok) {
            throw new Error(
              `HTTP Error: ${response.status} - ${response.statusText}`
            );
          }

          // open file in new tab directly
          window.open(linkFiles[0].link, "_blank");

          Swal.close();
          return;
        }

        for await (const { link, fileName } of linkFiles) {
          try {
            const response = await fetch(link);

            if (!response.ok) {
              throw new Error(
                `HTTP Error: ${response.status} - ${response.statusText}`
              );
            }

            const blob = await response.blob();
            zip.file(fileName, blob);
          } catch (error) {
            errorMessages.push(
              `Error downloading ${fileName}: ${error.message}`
            );
          }
        }

        if (errorMessages.length > 0) {
          console.error(errorMessages);
          Swal.fire("Desculpe!", "Erro ao baixar arquivos!", "error");
        } else {
          const content = await zip.generateAsync({ type: "blob" });

          const blobUrl = URL.createObjectURL(content);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `Documento_${new Date().toLocaleDateString(
            "pt-br"
          )}.zip`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);

          Swal.close();
          Swal.fire("Sucesso!", "Arquivos baixados com sucesso.", "success");
        }
      } catch (error) {
        console.error(error);
        Swal.fire("Desculpe!", "Erro ao baixar arquivos!", "error");
      }
    },
    [api]
  );

  const approveDocument = useCallback(
    async (documentId) => {
      setLoading(true);

      try {
        await api.makeHttpRequest({
          method: "PUT",
          url: `/document/update-status/${documentId}`,
          data: {
            status: DocumentStatusEnum.COMPLETED,
          },
        });

        Swal.fire("Sucesso!", "Documento aprovado com sucesso.", "success");
      } catch (error) {
        Swal.fire("Erro!", "Erro ao aprovar documento.", "error");
      } finally {
        setLoading(false);
        if (props?.handleGetParent) {
          props.handleGetParent();
        }
        setReload((prevReload) => !prevReload);
      }
    },
    [api, props, setReload, setLoading]
  );

  const rejectDocument = useCallback(
    async (id) => {
      try {
        setLoading(true);
        await api.makeHttpRequest({
          method: "PUT",
          url: `/document/update-status/${id}`,
          data: {
            status: DocumentStatusEnum.REJECTED,
            observation: observationReject,
          },
        });
        Swal.fire(
          "Sucesso!",
          "Documento rejeitado com sucesso.",
          "success"
        ).then(() => {
          setReload((prevReload) => !prevReload);
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao rejeitar documento.", "error");
      } finally {
        setLoading(false);
      }
    },
    [api, observationReject]
  );

  const handleOpenUploadModal = useCallback(
    (row, selectedFiles = []) => {
      if (!row) return;

      setShowUpload(true);
      setDocumentData({
        documentCategoryId: row.documentCategoryId,
        documentId: row?.id,
        lawsuitId: row?.lawsuitId,
        userId: props.userId,
      });

      if (selectedFiles.length > 0) {
        setFilesList(selectedFiles);
      } else if (
        row?.files?.length > 0 &&
        row?.status === DocumentStatusEnum.VALIDATING
      ) {
        const filesKeys = row?.files?.map((file) => ({
          name: file.name,
          fileKey: file.fileKey,
          id: file?.id,
          documentId: row?.id,
        }));

        setFilesList(filesKeys);
      } else {
        setFilesList([]);
      }
    },
    [props.userId]
  );

  const getDocumentList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document/list-paginated`,
        params: {
          lawsuitId: props.lawsuitId,
          ...(userRole === USER_ROLES.CLIENT ? { perPage: 1000 } : {}),
        },
        method: "GET",
      });
      const documents = response?.data || [];
      setDocumentList(documents);
      setSelectedUploadId((currentId) => {
        const selectableDocuments = documents.filter(
          (document) =>
            document.status === DocumentStatusEnum.PENDING ||
            document.status === DocumentStatusEnum.REJECTED
        );
        return selectableDocuments.some(
          (document) => String(document.id) === String(currentId)
        )
          ? currentId
          : selectableDocuments[0]?.id || "";
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api, props.lawsuitId, userRole]);

  const handlePreviewDocument = useCallback(
    async (row) => {
      const firstFile = row?.files?.find((file) => file.fileKey);
      if (!firstFile) {
        Swal.fire("Desculpe!", "Não contém arquivo!", "error");
        return;
      }

      try {
        const link = await api.makeHttpRequest({
          method: "GET",
          url: "/document/download",
          params: {
            fileKey: firstFile.fileKey,
            documentId: row.id,
          },
        });
        window.open(link, "_blank", "noopener,noreferrer");
      } catch (error) {
        Swal.fire("Desculpe!", "Erro ao visualizar o arquivo!", "error");
      }
    },
    [api]
  );

  const handlePremiumFileSelection = useCallback(
    (selectedFiles) => {
      const selectedDocument = documentList.find(
        (document) => String(document.id) === String(selectedUploadId)
      );
      if (selectedDocument) {
        handleOpenUploadModal(selectedDocument, Array.from(selectedFiles || []));
      }
    },
    [documentList, handleOpenUploadModal, selectedUploadId]
  );

  useEffect(() => {
    getDocumentList();
  }, [getDocumentList, props.reload]);

  const formatRow = (row) => {
    return (
      <StyledTableRow key={row.id} hover tabIndex={-1}>
        <StyledTableCell
          style={{
            padding: "4px 20px",
            textAlign: "left",
            width: "120px",
          }}
        >
          <Container
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              padding: 0,
              margin: 0,
            }}
          >
            {row.status !== DocumentStatusEnum.COMPLETED && (
              <SvgIcon
                component={paperClipIcon}
                onClick={() => {
                  handleOpenUploadModal(row);
                }}
                style={{
                  width: "20px",
                  height: "20px",
                  color: globalColors.backgroundColor2,
                  fill: "transparent",
                  cursor: "pointer",
                  marginRight: "10px",
                  display: "block",
                }}
                title={"Anexar documento"}
              />
            )}
            <div
              style={{
                display:
                  row?.status === DocumentStatusEnum.VALIDATING
                    ? "none"
                    : "flex",
                padding: 0,
                margin: 0,
              }}
            >
              <CrudActions
                actions={crudActions}
                module="processo"
                align="flex-start"
                onConfirmChangeStatus={handleConfirmChangeStatus}
                onConfirmDelete={handleConfirmDelete}
                id={row.id}
                obj={row}
                titleMessageDelete={""}
                addMessage={"Deseja deletar esse documento?"}
              />
            </div>
            <CrudActions
              actions={crudOtherActions}
              module="processo"
              onConfirmDelete={handleConfirmDelete}
              onConfirmDownload={() => handleDownloadAll(row.files, row.id)}
              id={row.id}
              obj={row}
              titleMessageDelete={""}
              addMessage={"Deseja deletar esse documento?"}
            />
            <SvgIcon
              component={approvedIcon}
              onClick={() => {
                approveDocument(row.id);
              }}
              style={{
                width: "20px",
                height: "20px",
                color: globalColors.backgroundColor2,
                marginRight: "10px",
                fill: "transparent",
                cursor: "pointer",
                display: getDisplayFromStatusHelperToAproveRejectDocuments(
                  row.status,
                  auth.user
                ),
              }}
              title={"Aprovar documento anexado"}
            />
            <SvgIcon
              component={deniedIcon}
              onClick={() => {
                setObservationReject("");
                setRejectingDocumentId(row.id);
                setShowRejectModal(true);
              }}
              style={{
                width: "20px",
                height: "20px",
                color: globalColors.backgroundColor2,
                fill: "transparent",
                cursor: "pointer",
                display:
                  row.status == DocumentStatusEnum.COMPLETED
                    ? "block"
                    : getDisplayFromStatusHelper(row.status, auth.user),
              }}
              title={"Rejeitar documento anexado"}
            />
            <SvgIcon
              component={informationIcon}
              onClick={() => {
                setObservationReject(row.observation);
                setShowRejectModalInfo(true);
              }}
              style={{
                width: "20px",
                height: "20px",
                color: globalColors.backgroundColor2,
                fill: "transparent",
                cursor: "pointer",
                display:
                  row.status === DocumentStatusEnum.REJECTED ? "block" : "none",
              }}
              title={"Informações sobre a rejeição"}
            />
          </Container>
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row?.lawsuit?.user?.id ? (
            <Link to={`/admin/usuario/${row?.lawsuit?.user?.id}/editar`}>
              {row?.lawsuit?.user?.username}
            </Link>
          ) : row?.user?.id ? (
            <Link to={`/admin/usuario/${row?.user?.id}/editar`}>
              {row?.user?.username}
            </Link>
          ) : (
            "-"
          )}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row?.lawsuit?.action?.action ? row?.lawsuit?.action?.action : "-"}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row?.documentCategory?.name}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row?.lawsuit?.adverseParty ? row?.lawsuit?.adverseParty : "-"}
        </StyledTableCell>
        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row?.lawsuit?.id ? (
            <Link to={`/admin/processo/${row.lawsuit.id}/editar`}>
              {row.lawsuit.courtCaseNumber}
            </Link>
          ) : (
            "-"
          )}
        </StyledTableCell>
        {auth.user.role === USER_ROLES.ADMIN && (
          <StyledTableCell
            scope="row"
            style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
          >
            {row?.user?.id
              ? "Cliente"
              : row?.lawsuit?.id
              ? "Processo"
              : "Nenhum link disponível"}
          </StyledTableCell>
        )}

        <StyledTableCell
          style={{
            padding: "4px 0px",
            textAlign: "center",
            width: "100px",
          }}
        >
          <Typography
            className="xv-status-badge"
            data-status={row.status}
            style={{
              backgroundColor: getLabelAndColorFromStatusHelper(row.status)
                .color,
              display: "inline-block",
              padding: "4px 6px",
              borderRadius: "4px",
              fontWeight: "500",
              color: getLabelAndColorFromStatusHelper(row.status).textColor,
            }}
          >
            {getLabelAndColorFromStatusHelper(row.status).label}
          </Typography>
        </StyledTableCell>

        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {row.lawsuit?.limitDate
            ? new Date(row.lawsuit?.limitDate).toLocaleDateString("pt-BR")
            : "-"}
        </StyledTableCell>

        <StyledTableCell
          scope="row"
          style={{ padding: "4px 0px", textAlign: "left", paddingLeft: 10 }}
        >
          {new Date(row.updatedAt).toLocaleString("pt-BR")}
        </StyledTableCell>
      </StyledTableRow>
    );
  };

  const [filesList, setFilesList] = useState([]);

  return (
    <>
      <Loading isLoading={loading} />
      <UploadModal
        open={showUpload}
        handleOpen={setShowUpload}
        dados={documentData}
        setReload={setReload}
        reload={reload}
        handleGetDocuments={getDocumentList}
        filesList={filesList}
        refetchLogs={props.refetchLogs || (() => {})}
      />
      {isXavierThemeV2Enabled() && auth.user.role === USER_ROLES.CLIENT ? (
        <div className={styles.clientDocuments}>
          <section className={styles.metrics} aria-label="Resumo dos documentos">
            {[
              {
                label: "Pendentes",
                value: documentList.filter(
                  (document) => document.status === DocumentStatusEnum.PENDING
                ).length,
              },
              {
                label: "Recebidos",
                value: documentList.filter(
                  (document) => document.status === DocumentStatusEnum.VALIDATING
                ).length,
              },
              {
                label: "Validados",
                value: documentList.filter(
                  (document) => document.status === DocumentStatusEnum.COMPLETED
                ).length,
              },
              { label: "Total", value: documentList.length },
            ].map((metric) => (
              <article className={styles.metricCard} key={metric.label}>
                <strong>{metric.value}</strong>
                <span>{metric.label}</span>
              </article>
            ))}
          </section>

          <section className={styles.uploadPanel}>
            <div className={styles.sectionHeading}>
              <div>
                <h2>Enviar Documento</h2>
                <p>Faça upload dos documentos solicitados pelo escritório</p>
              </div>
              <span className={styles.headingIcon} aria-hidden="true">
                <FiUpload />
              </span>
            </div>

            {documentList.some(
              (document) =>
                document.status === DocumentStatusEnum.PENDING ||
                document.status === DocumentStatusEnum.REJECTED
            ) ? (
              <>
                <label className={styles.requestSelectLabel}>
                  Solicitação relacionada
                  <div className={styles.requestSearchSelect}>
                    <input
                      type="text"
                      role="combobox"
                      aria-expanded={requestMenuOpen}
                      aria-controls="upload-request-options"
                      value={
                        requestMenuOpen
                          ? requestSearch
                          : selectedUploadRequest?.label || ""
                      }
                      onFocus={() => {
                        setRequestSearch("");
                        setRequestMenuOpen(true);
                      }}
                      onChange={(event) => {
                        setRequestSearch(event.target.value);
                        setRequestMenuOpen(true);
                      }}
                      onBlur={() => setRequestMenuOpen(false)}
                      placeholder="Digite para buscar uma solicitação..."
                      autoComplete="off"
                    />
                    <FiChevronDown className={styles.requestSearchArrow} aria-hidden="true" />
                    {requestMenuOpen && (
                      <div
                        id="upload-request-options"
                        className={styles.requestSearchMenu}
                        role="listbox"
                      >
                        {filteredUploadRequestOptions.length ? (
                          filteredUploadRequestOptions.map((option) => (
                            <div
                              className={`${styles.requestSearchOption} ${
                                String(option.value) === String(selectedUploadId)
                                  ? styles.requestSearchOptionSelected
                                  : ""
                              }`}
                              role="option"
                              aria-selected={
                                String(option.value) === String(selectedUploadId)
                              }
                              key={option.value}
                              onMouseDown={(event) => {
                                event.preventDefault();
                                setSelectedUploadId(option.value);
                                setRequestSearch("");
                                setRequestMenuOpen(false);
                              }}
                            >
                              {option.label}
                            </div>
                          ))
                        ) : (
                          <div className={styles.requestSearchEmpty}>
                            Nenhuma solicitação encontrada
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </label>
                <label
                  className={styles.pageDropzone}
                  htmlFor="premium-document-upload"
                  onDragOver={(event) => event.preventDefault()}
                  onDrop={(event) => {
                    event.preventDefault();
                    handlePremiumFileSelection(event.dataTransfer.files);
                  }}
                >
                  <span className={styles.dropzoneIcon} aria-hidden="true">
                    <FiUpload />
                  </span>
                  <strong>Arraste arquivos aqui ou clique para selecionar</strong>
                  <small>PDF, JPG, PNG — Máximo 125 MB por arquivo</small>
                  <input
                    id="premium-document-upload"
                    type="file"
                    multiple
                    onChange={(event) => {
                      handlePremiumFileSelection(event.target.files);
                      event.target.value = "";
                    }}
                    hidden
                  />
                </label>
              </>
            ) : (
              <div className={styles.noPendingDocuments}>
                <FiCheckCircle />
                <span>Não há documentos aguardando envio.</span>
              </div>
            )}
          </section>

          <section className={styles.requestedDocuments}>
            <div className={styles.sectionHeading}>
              <h2>Documentos Solicitados</h2>
              <span className={styles.headingIcon} aria-hidden="true">
                <FiFileText />
              </span>
            </div>

            <div className={styles.documentList}>
              {documentList.length > 0 ? (
                documentList.map((row) => {
                  const status =
                    row.status === DocumentStatusEnum.PENDING
                      ? "Aguardando envio"
                      : row.status === DocumentStatusEnum.VALIDATING
                      ? "Recebido"
                      : row.status === DocumentStatusEnum.COMPLETED
                      ? "Validado"
                      : "Rejeitado";
                  const canSend =
                    row.status === DocumentStatusEnum.PENDING ||
                    row.status === DocumentStatusEnum.REJECTED;
                  const hasFiles = row?.files?.length > 0;
                  const context = [
                    row?.lawsuit?.action?.action,
                    row?.lawsuit?.adverseParty,
                  ]
                    .filter(Boolean)
                    .join(" — ");

                  return (
                    <article className={styles.documentCard} key={row.id}>
                      <span className={styles.documentIcon} aria-hidden="true">
                        <FiFileText />
                      </span>
                      <div className={styles.documentInfo}>
                        <h3>
                          {row?.documentCategory?.name || "Documento solicitado"}
                        </h3>
                        <p>
                          {context || "Solicitação do escritório"}
                          {row?.createdAt || row?.updatedAt
                            ? ` — Solicitado em ${new Date(
                                row.createdAt || row.updatedAt
                              ).toLocaleDateString("pt-BR")}`
                            : ""}
                        </p>
                      </div>
                      <span className={styles.statusBadge} data-status={row.status}>
                        {row.status === DocumentStatusEnum.PENDING ? (
                          <FiClock />
                        ) : (
                          <FiCheckCircle />
                        )}
                        {status}
                      </span>
                      <div className={styles.documentActions}>
                        {canSend && (
                          <button
                            type="button"
                            className={styles.sendButton}
                            onClick={() => handleOpenUploadModal(row)}
                          >
                            <FiUpload />
                            Enviar
                          </button>
                        )}
                        {!canSend && hasFiles && (
                          <button
                            type="button"
                            className={styles.iconButton}
                            onClick={() =>
                              row.status === DocumentStatusEnum.VALIDATING
                                ? handleOpenUploadModal(row)
                                : handlePreviewDocument(row)
                            }
                            aria-label={`Visualizar ${
                              row?.documentCategory?.name || "documento"
                            }`}
                            title="Visualizar documento"
                          >
                            <FiEye />
                          </button>
                        )}
                        {hasFiles && (
                          <button
                            type="button"
                            className={styles.iconButton}
                            onClick={() => handleDownloadAll(row.files, row.id)}
                            aria-label={`Baixar ${
                              row?.documentCategory?.name || "documento"
                            }`}
                            title="Baixar documento"
                          >
                            <FiDownload />
                          </button>
                        )}
                      </div>
                    </article>
                  );
                })
              ) : (
                <div className={styles.emptyState}>
                  Nenhum documento solicitado.
                </div>
              )}
            </div>
          </section>
        </div>
      ) : (
      <DatatableDocuments
        title={
          isXavierThemeV2Enabled()
            ? "Documentos Solicitados"
            : "Acompanhamento Documentos"
        }
        hideTitle={isXavierThemeV2Enabled()}
        icon={<img src={documentImage} alt="documentos" />}
        // Filtro de status para documentos automático no back-end
        endpoint={`/document/list-paginated`}
        className="bg-white"
        headRows={headRows}
        formatRow={formatRow}
        rows={[]}
        reload={reload}
        placeholderSearch="Busque por Usuário, nº autos ou Documento"
        width={props.width}
        hiddenReload
        personInputs
        hiddenKanbanContent
      />
      )}
      <RejectingDocumentModal
        open={showRejectModal}
        handleOpen={setShowRejectModal}
        observationReject={observationReject}
        setObservationReject={setObservationReject}
        rejectingDocumentId={rejectingDocumentId}
        rejectDocument={rejectDocument}
      />
      <RejectingDocumentModalInfo
        open={showRejectModalInfo}
        handleOpen={setShowRejectModalInfo}
        observationReject={observationReject}
      />
    </>
  );
};

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
});

export default connect(mapStateToProps)(DocumentValidation);
